import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { ADDITIONAL_INFORMATION_PAGE_PATH } from "utils/constants/paths";

const AdditionalInformationPage = Loadable(React.lazy(() => import("./View")));

export const AdditionalInformationPageRoute: IRouteItem = {
  path: ADDITIONAL_INFORMATION_PAGE_PATH,
  element: React.createElement(AdditionalInformationPage),
  name: "Additional Information",
};
